(function(window, document, undefined) {
'use strict';
// Source: wb.directives.js
angular.module('wb.directives', ['mgcrea.ngStrap', 'pascalprecht.translate']);

// Source: wbBusyIndicator.js
angular.module('wb.directives')

    .directive('wbBusyIndicator', ['$tooltip', function ($tooltip) {
        return {
            restrict: 'A',
            priority: 100000,
            scope: true,
            link: function link($scope, element, attributes) {
                var oldHtml = element.html();
                var changed = false;
                var tooltipMode = false;
                var busyTooltip = null;
                $scope.tooltipTop = 100;
                $scope.$watch(attributes.wbBusyIndicator, function (val) {
                    if (val) {
                        if (attributes.wbBusyIndicatorOverlay) {

                            var marginTop = Math.min(350, element.height() / 3);


                            tooltipMode = true;
                            var tooltipCfg = {
                                trigger: 'manual',
                                placement: 'top center',
                                template: 'busyIndicator/templates/wb-busy-indicator.tpl.html'//,
                              //  target: 'body'
                            };
                            busyTooltip = $tooltip(element, tooltipCfg);
                            busyTooltip.$promise.then(function() {
                                busyTooltip.show();
                                element.next().css({ 'margin-top': marginTop + 'px'});
                            });
                        } else {
                            oldHtml = element.html();
                            element.html("<i class='fa-lg fa fa-spinner fa-spin'></i>");
                        }
                        changed = true;
                    } else {
                        if (changed) {
                            if (tooltipMode) {
                                busyTooltip.$promise.then(function() {
                                    busyTooltip.hide();
                                });
                            } else {
                                element.html(oldHtml);
                            }
                        }
                    }
                }, true);

            }
        }
    }]);

// Source: wbCheckboxBitmaskEdit.js
angular.module('wb.directives')
    .directive('wbCheckboxBitmaskEdit',
        function () {
            return {
                restrict: 'AE',
                require: 'ngModel',
                priority: 1,
                scope: {
                    ngModel: '=ngModel',
                    value: '='
                },
                replace: true,
                templateUrl: 'checkbox/templates/wb-checkbox-bitmask-edit.tpl.html',
                link: function (scope, element, attr, ctrl) {

                    scope.spanChecked = 0;

                    scope.spanClick = function ($event) {
                        ctrl.$setViewValue(scope.spanChecked
                            ? ctrl.$viewValue & ~scope.value
                            : ctrl.$viewValue | scope.value, $event.type);
                        scope.spanChecked = (ctrl.$viewValue & scope.value) > 0;
                        $event.preventDefault();
                        $(element).focus();
                    };

                    ctrl.$render = function () {
                        scope.spanChecked = (ctrl.$viewValue & scope.value) > 0;
                    };
                }
            }
        });

// Source: wbCheckboxEdit.js
angular.module('wb.directives')
    .directive('wbCheckboxEdit', 
        function () {
            return {
                restrict: 'A',
                require: 'ngModel',
                priority: 1,
                scope: {
                    ngModel: '=ngModel',
                    indeterminate: '='
                },
                replace: true,
                templateUrl: 'checkbox/templates/wb-checkbox-edit.tpl.html',
                link: function (scope, element, attr, ctrl) {

                    scope.spanClick = function ($event) {
                        scope.spanChecked = negateValue(scope.spanChecked);
                        ctrl.$setViewValue(toViewValue(scope.spanChecked), $event.type);
                        $event.preventDefault();
                        $(element).focus();
                    }

                    ctrl.$render = function () {
                        scope.spanChecked = fromViewValue(ctrl.$viewValue);
                    };

                    function negateValue(value) {
                        if (value === 0) {
                            return 1;
                        }
                        return 0;

                    }

                    function toViewValue(viewValue) {
                        if (viewValue === 1) {
                            return true;
                        } else if (viewValue === 0) {
                            return false;
                        } else if (viewValue === 'indeterminate') {
                            return viewValue;
                        } else {
                            return false;
                        }
                    }

                    function fromViewValue(value) {
                        if (value === true || value === 'true') {
                            return 1;
                        } else if (value === false || value === 'false') {
                            return 0;
                        } else if (value === 'indeterminate') {
                            return value;
                        } else {
                            return 0;
                        }
                    }

                    scope.spanChecked = fromViewValue(ctrl.$viewValue);
                    ctrl.$render();    
                }
            }
        });

// Source: wbRadioEdit.js
angular.module('wb.directives')
    .directive('wbRadioEdit',
        function () {
            return {
                restrict: 'A',
                require: 'ngModel',
                priority: 1,
                scope: {
                    ngModel: '=ngModel',
                    value: '='
                },
                replace: true,
                templateUrl: 'checkbox/templates/wb-radio-edit.tpl.html',
                link: function (scope, element, attr, ctrl) {

                    scope.spanChecked = 0;

                    scope.spanClick = function ($event) {
                        ctrl.$setViewValue(scope.value, $event.type);
                        scope.spanChecked = true;
                        $event.preventDefault();
                        $(element).focus();
                    }

                    ctrl.$render = function () {
                        scope.spanChecked = ctrl.$viewValue == scope.value;
                    };
                }
            }
        });

// Source: l10n-cs.js
angular.module('wb.directives')
    .config(['$translateProvider',
        function ($translateProvider) {
            $translateProvider.translations('cs', {
                    TXT_TODAY: 'Dnes',
                    TXT_BUSY: 'Prosím čekejte',
                    TXT_LBL_START_DATE: 'Začátek',
                    TXT_LBL_END_DATE: 'Konec',
                    TXT_LBL_EMPLOYEE: 'Učitel',
                    TXT_LBL_NAME: 'Název',
                    TXT_LBL_FILLED: 'Obsazeno',
                    TXT_NOTE: 'Poznámka',
                    TXT_RECURRENCE_TYPE_DAILY: 'Denně',
                    TXT_RECURRENCE_TYPE_WEEKLY: 'Týdně',
                    TXT_RECURRENCE_TYPE_MONTHLY: 'Měsíčně',
                    TXT_RECURRENCE_TYPE_YEARLY: 'Ročně',
                    TXT_RECURRENCE_WEEK_DAYS_SUNDAY: 'Ne',
                    TXT_RECURRENCE_WEEK_DAYS_MONDAY: 'Po',
                    TXT_RECURRENCE_WEEK_DAYS_TUESDAY: 'Út',
                    TXT_RECURRENCE_WEEK_DAYS_WEDNESDAY: 'St',
                    TXT_RECURRENCE_WEEK_DAYS_THURSDAY: 'Čt',
                    TXT_RECURRENCE_WEEK_DAYS_FRIDAY: 'Pá',
                    TXT_RECURRENCE_WEEK_DAYS_SATURDAY: 'So',
                    TXT_RECURRENCE_WEEK_EVERY_1: 'Opakuje se každý',
                    TXT_RECURRENCE_WEEK_EVERY_2: 'Opakuje se každé',
                    TXT_RECURRENCE_WEEK_EVERY_3: 'Opakuje se každých',
                    TXT_RECURRENCE_WEEK_1: 'týden',
                    TXT_RECURRENCE_WEEK_2: 'týdny',
                    TXT_RECURRENCE_WEEK_3: 'týdnů',
                    TXT_RECURRENCE_DAY_1: 'den',
                    TXT_RECURRENCE_DAY_2: 'dny',
                    TXT_RECURRENCE_DAY_3: 'dnů',
                    TXT_RECURRENCE_WEEK_WORKDAY: 'pracovní den',
                    TXT_RECURRENCE_MONTH_EVERY_1: 'Každý',
                    TXT_RECURRENCE_MONTH_EVERY_2: 'Každé',
                    TXT_RECURRENCE_MONTH_EVERY_3: 'Každých',
                    TXT_RECURRENCE_MONTH_FROM_EVERY: 'každého',
                    TXT_RECURRENCE_MONTH_MONTH: 'měsíce',
                    TXT_RECURRENCE_WEEK_OF_MONTH_FIRST: 'první',
                    TXT_RECURRENCE_WEEK_OF_MONTH_SECOND: 'druhý',
                    TXT_RECURRENCE_WEEK_OF_MONTH_THIRD: 'třetí',
                    TXT_RECURRENCE_WEEK_OF_MONTH_FOURTH: 'čtvrtý',
                    TXT_RECURRENCE_WEEK_OF_MONTH_LAST: 'poslední',
                    TXT_RECURRENCE_MONTH_JANUARY: 'leden',
                    TXT_RECURRENCE_MONTH_FEBRUARY: 'únor',
                    TXT_RECURRENCE_MONTH_MARCH: 'březen',
                    TXT_RECURRENCE_MONTH_APRIL: 'duben',
                    TXT_RECURRENCE_MONTH_MAY: 'květen',
                    TXT_RECURRENCE_MONTH_JUNE: 'červen',
                    TXT_RECURRENCE_MONTH_JULY: 'červenec',
                    TXT_RECURRENCE_MONTH_AUGUST: 'srpen',
                    TXT_RECURRENCE_MONTH_SEPTEMBER: 'září',
                    TXT_RECURRENCE_MONTH_OCTOBER: 'říjen',
                    TXT_RECURRENCE_MONTH_NOVEMBER: 'listopad',
                    TXT_RECURRENCE_MONTH_DECEMBER: 'prosinec',
                    TXT_RECURRENCE_IN: 'v',
                    TXT_RECURRENCE_ENDS_AFTER: 'Končí po',
                    TXT_RECURRENCE_ENDS_AT: 'Končí dne',
                    TXT_RECURRENCE_OCCURRENCES: 'výskytech'
                }
            );
        }
    ]);

// Source: l10n-de.js
angular.module('wb.directives')
    .config(['$translateProvider',
            function ($translateProvider) {
                    $translateProvider.translations('de', {
                                TXT_TODAY: 'Heute',
                                TXT_BUSY: 'Bitte warten',
                                TXT_LBL_START_DATE: 'Anfang',
                                TXT_LBL_END_DATE: 'Ende',
                                TXT_LBL_EMPLOYEE: 'Lehrer',
                                TXT_LBL_NAME: 'Name',
                                TXT_LBL_FILLED: 'Belegt',
                                TXT_NOTE: 'Notiz',
                                TXT_RECURRENCE_TYPE_DAILY: 'Täglich',
                                TXT_RECURRENCE_TYPE_WEEKLY: 'Wöchentlich',
                                TXT_RECURRENCE_TYPE_MONTHLY: 'Monatlich',
                                TXT_RECURRENCE_TYPE_YEARLY: 'Jährlich',
                                TXT_RECURRENCE_WEEK_DAYS_SUNDAY: 'So',
                                TXT_RECURRENCE_WEEK_DAYS_MONDAY: 'Mo',
                                TXT_RECURRENCE_WEEK_DAYS_TUESDAY: 'Di',
                                TXT_RECURRENCE_WEEK_DAYS_WEDNESDAY: 'Mi',
                                TXT_RECURRENCE_WEEK_DAYS_THURSDAY: 'Do',
                                TXT_RECURRENCE_WEEK_DAYS_FRIDAY: 'Fr',
                                TXT_RECURRENCE_WEEK_DAYS_SATURDAY: 'Sa',
                                TXT_RECURRENCE_WEEK_EVERY_1: 'Wiederholt sich jede',
                                TXT_RECURRENCE_WEEK_EVERY_2: 'Wiederholt sich jede',
                                TXT_RECURRENCE_WEEK_EVERY_3: 'Wiederholt sich jede',
                                TXT_RECURRENCE_WEEK_1: 'Woche',
                                TXT_RECURRENCE_WEEK_2: 'Wochen',
                                TXT_RECURRENCE_WEEK_3: 'Wochen',
                                TXT_RECURRENCE_DAY_1: 'Tag',
                                TXT_RECURRENCE_DAY_2: 'Tage',
                                TXT_RECURRENCE_DAY_3: 'Tage',
                                TXT_RECURRENCE_WEEK_WORKDAY: 'Arbeitstag',
                                TXT_RECURRENCE_MONTH_EVERY_1: 'Jeden',
                                TXT_RECURRENCE_MONTH_EVERY_2: 'Jedes',
                                TXT_RECURRENCE_MONTH_EVERY_3: 'Jede',
                                TXT_RECURRENCE_MONTH_FROM_EVERY: 'jeden',
                                TXT_RECURRENCE_MONTH_MONTH: 'Monat',
                                TXT_RECURRENCE_WEEK_OF_MONTH_FIRST: 'erste',
                                TXT_RECURRENCE_WEEK_OF_MONTH_SECOND: 'zweite',
                                TXT_RECURRENCE_WEEK_OF_MONTH_THIRD: 'dritte',
                                TXT_RECURRENCE_WEEK_OF_MONTH_FOURTH: 'vierte',
                                TXT_RECURRENCE_WEEK_OF_MONTH_LAST: 'letzte',
                                TXT_RECURRENCE_MONTH_JANUARY: 'Januar',
                                TXT_RECURRENCE_MONTH_FEBRUARY: 'Februar',
                                TXT_RECURRENCE_MONTH_MARCH: 'März',
                                TXT_RECURRENCE_MONTH_APRIL: 'April',
                                TXT_RECURRENCE_MONTH_MAY: 'Mai',
                                TXT_RECURRENCE_MONTH_JUNE: 'Juni',
                                TXT_RECURRENCE_MONTH_JULY: 'Juli',
                                TXT_RECURRENCE_MONTH_AUGUST: 'August',
                                TXT_RECURRENCE_MONTH_SEPTEMBER: 'September',
                                TXT_RECURRENCE_MONTH_OCTOBER: 'Oktober',
                                TXT_RECURRENCE_MONTH_NOVEMBER: 'November',
                                TXT_RECURRENCE_MONTH_DECEMBER: 'Dezember',
                                TXT_RECURRENCE_IN: 'in',
                                TXT_RECURRENCE_ENDS_AFTER: 'Endet nach',
                                TXT_RECURRENCE_ENDS_AT: 'Endet am',
                                TXT_RECURRENCE_OCCURRENCES: 'Vorkommen'
                        }
                    );
            }
    ]);

// Source: l10n-en.js
angular.module('wb.directives')
    .config(['$translateProvider',
        function ($translateProvider) {
            $translateProvider.translations('en', {
                    TXT_TODAY: 'Today',
                    TXT_BUSY: 'Please wait',
                    TXT_LBL_START_DATE: 'Start',
                    TXT_LBL_END_DATE: 'End',
                    TXT_LBL_EMPLOYEE: 'Teacher',
                    TXT_LBL_NAME: 'Name',
                    TXT_LBL_FILLED: 'Filled',
                    TXT_NOTE: 'Note',
                    TXT_RECURRENCE_TYPE_DAILY: 'Daily',
                    TXT_RECURRENCE_TYPE_WEEKLY: 'Weekly',
                    TXT_RECURRENCE_TYPE_MONTHLY: 'Monthly',
                    TXT_RECURRENCE_TYPE_YEARLY: 'Yearly',
                    TXT_RECURRENCE_WEEK_DAYS_SUNDAY: 'Su',
                    TXT_RECURRENCE_WEEK_DAYS_MONDAY: 'Mo',
                    TXT_RECURRENCE_WEEK_DAYS_TUESDAY: 'Tu',
                    TXT_RECURRENCE_WEEK_DAYS_WEDNESDAY: 'We',
                    TXT_RECURRENCE_WEEK_DAYS_THURSDAY: 'Th',
                    TXT_RECURRENCE_WEEK_DAYS_FRIDAY: 'Fr',
                    TXT_RECURRENCE_WEEK_DAYS_SATURDAY: 'Sa',
                    TXT_RECURRENCE_WEEK_EVERY_1: 'Repeats every',
                    TXT_RECURRENCE_WEEK_EVERY_2: 'Repeats every',
                    TXT_RECURRENCE_WEEK_EVERY_3: 'Repeats every',
                    TXT_RECURRENCE_WEEK_1: 'week',
                    TXT_RECURRENCE_WEEK_2: 'weeks',
                    TXT_RECURRENCE_WEEK_3: 'weeks',
                    TXT_RECURRENCE_DAY_1: 'day',
                    TXT_RECURRENCE_DAY_2: 'days',
                    TXT_RECURRENCE_DAY_3: 'days',
                    TXT_RECURRENCE_WEEK_WORKDAY: 'work day',
                    TXT_RECURRENCE_MONTH_EVERY_1: 'Every',
                    TXT_RECURRENCE_MONTH_EVERY_2: 'Every',
                    TXT_RECURRENCE_MONTH_EVERY_3: 'Every',
                    TXT_RECURRENCE_MONTH_FROM_EVERY: 'on every',
                    TXT_RECURRENCE_MONTH_MONTH: 'month',
                    TXT_RECURRENCE_WEEK_OF_MONTH_FIRST: 'first',
                    TXT_RECURRENCE_WEEK_OF_MONTH_SECOND: 'second',
                    TXT_RECURRENCE_WEEK_OF_MONTH_THIRD: 'third',
                    TXT_RECURRENCE_WEEK_OF_MONTH_FOURTH: 'fourth',
                    TXT_RECURRENCE_WEEK_OF_MONTH_LAST: 'last',
                    TXT_RECURRENCE_MONTH_JANUARY: 'january',
                    TXT_RECURRENCE_MONTH_FEBRUARY: 'february',
                    TXT_RECURRENCE_MONTH_MARCH: 'march',
                    TXT_RECURRENCE_MONTH_APRIL: 'april',
                    TXT_RECURRENCE_MONTH_MAY: 'may',
                    TXT_RECURRENCE_MONTH_JUNE: 'june',
                    TXT_RECURRENCE_MONTH_JULY: 'july',
                    TXT_RECURRENCE_MONTH_AUGUST: 'august',
                    TXT_RECURRENCE_MONTH_SEPTEMBER: 'september',
                    TXT_RECURRENCE_MONTH_OCTOBER: 'october',
                    TXT_RECURRENCE_MONTH_NOVEMBER: 'november',
                    TXT_RECURRENCE_MONTH_DECEMBER: 'december',
                    TXT_RECURRENCE_IN: 'in',
                    TXT_RECURRENCE_ENDS_AFTER: 'Ends after',
                    TXT_RECURRENCE_ENDS_AT: 'Ends at',
                    TXT_RECURRENCE_OCCURRENCES: 'occurrences'
                }
            );
        }
    ]);

// Source: l10n-sk.js
angular.module('wb.directives')
    .config(['$translateProvider',
        function ($translateProvider) {
            $translateProvider.translations('sk', {
                    TXT_TODAY: 'Dnes',
                    TXT_BUSY: 'Prosím čakajte',
                    TXT_LBL_START_DATE: 'Začiatok',
                    TXT_LBL_END_DATE: 'Koniec',
                    TXT_LBL_EMPLOYEE: 'Učiteľ',
                    TXT_LBL_NAME: 'Názov',
                    TXT_LBL_FILLED: 'Obsadené',
                    TXT_NOTE: 'Poznámka',
                    TXT_RECURRENCE_TYPE_DAILY: 'Denne',
                    TXT_RECURRENCE_TYPE_WEEKLY: 'Týždenne',
                    TXT_RECURRENCE_TYPE_MONTHLY: 'Mesačne',
                    TXT_RECURRENCE_TYPE_YEARLY: 'Ročne',
                    TXT_RECURRENCE_WEEK_DAYS_SUNDAY: 'Ne',
                    TXT_RECURRENCE_WEEK_DAYS_MONDAY: 'Po',
                    TXT_RECURRENCE_WEEK_DAYS_TUESDAY: 'Ut',
                    TXT_RECURRENCE_WEEK_DAYS_WEDNESDAY: 'St',
                    TXT_RECURRENCE_WEEK_DAYS_THURSDAY: 'Št',
                    TXT_RECURRENCE_WEEK_DAYS_FRIDAY: 'Pi',
                    TXT_RECURRENCE_WEEK_DAYS_SATURDAY: 'So',
                    TXT_RECURRENCE_WEEK_EVERY_1: 'Opakuje sa každý',
                    TXT_RECURRENCE_WEEK_EVERY_2: 'Opakuje sa každé',
                    TXT_RECURRENCE_WEEK_EVERY_3: 'Opakuje sa každých',
                    TXT_RECURRENCE_WEEK_1: 'týždeň',
                    TXT_RECURRENCE_WEEK_2: 'týždne',
                    TXT_RECURRENCE_WEEK_3: 'týždňov',
                    TXT_RECURRENCE_DAY_1: 'deň',
                    TXT_RECURRENCE_DAY_2: 'dni',
                    TXT_RECURRENCE_DAY_3: 'dní',
                    TXT_RECURRENCE_WEEK_WORKDAY: 'pracovný deň',
                    TXT_RECURRENCE_MONTH_EVERY_1: 'Každý',
                    TXT_RECURRENCE_MONTH_EVERY_2: 'Každé',
                    TXT_RECURRENCE_MONTH_EVERY_3: 'Každých',
                    TXT_RECURRENCE_MONTH_FROM_EVERY: 'každého',
                    TXT_RECURRENCE_MONTH_MONTH: 'mesiac',
                    TXT_RECURRENCE_WEEK_OF_MONTH_FIRST: 'prvý',
                    TXT_RECURRENCE_WEEK_OF_MONTH_SECOND: 'druhý',
                    TXT_RECURRENCE_WEEK_OF_MONTH_THIRD: 'tretí',
                    TXT_RECURRENCE_WEEK_OF_MONTH_FOURTH: 'štvrtý',
                    TXT_RECURRENCE_WEEK_OF_MONTH_LAST: 'posledný',
                    TXT_RECURRENCE_MONTH_JANUARY: 'január',
                    TXT_RECURRENCE_MONTH_FEBRUARY: 'február',
                    TXT_RECURRENCE_MONTH_MARCH: 'marec',
                    TXT_RECURRENCE_MONTH_APRIL: 'apríl',
                    TXT_RECURRENCE_MONTH_MAY: 'máj',
                    TXT_RECURRENCE_MONTH_JUNE: 'jún',
                    TXT_RECURRENCE_MONTH_JULY: 'júl',
                    TXT_RECURRENCE_MONTH_AUGUST: 'august',
                    TXT_RECURRENCE_MONTH_SEPTEMBER: 'september',
                    TXT_RECURRENCE_MONTH_OCTOBER: 'október',
                    TXT_RECURRENCE_MONTH_NOVEMBER: 'november',
                    TXT_RECURRENCE_MONTH_DECEMBER: 'december',
                    TXT_RECURRENCE_IN: 'v',
                    TXT_RECURRENCE_ENDS_AFTER: 'Končí po',
                    TXT_RECURRENCE_ENDS_AT: 'Končí dňa',
                    TXT_RECURRENCE_OCCURRENCES: 'výskytoch'
                }
            );
        }
    ]);

// Source: wbRightClick.js
angular.module('wb.directives')
    .directive('wbRightClick', ["$parse", function($parse) {
        return function(scope, element, attrs) {
            var fn = $parse(attrs.wbRightClick);
            element.bind('contextmenu', function(event) {
                scope.$apply(function() {
                    event.preventDefault();
                    fn(scope, {$event:event});
                });
            });
        };
    }]);

// Source: wbScheduler.js
angular.module('wb.directives')

    .directive('wbScheduler', ['$timeout', '$dropdown', '$translate', '$rootScope', 'wbSchedulerSvc',
        function($timeout, $dropdown, $translate, $rootScope, wbSchedulerSvc) {
// TODO: Display hourglass when there is a wait queue

        var defaultSettings = {
            weekView: true,
            autoHourRange: false,
            startHour: 8,
            endHour: 20,
            scale: 15,
            width: '1000px',
            noHeader: false,
            showWeekend: false,
            toolTipDelay: 800,
            toolTipTemplateUrl: 'scheduler/templates/wb-scheduler-tooltip.tpl.html',
            toolTipTrigger: 'hover',
            showRecurrence: false,
            selectedResourceID: 0,
            startDate: new Date(),
            columns: [],
            resources: [],
            rows: [],
            events: [],
            commands: [],
            selectByBlocks: 1,
            maximumSelectedBlocks: -1,
            startTimeType: -1, // 1 - CanStartAtWholeOrHalfHour, 2 - CanStartAtWholeHourOnly, 3 - CanStartAtHalfHourOnly, -1 ignore
        };

        return {
            restrict: 'E',
            scope: {
                sourceSettings: '=settings',
                actionClicked: '&onActionClicked',
                selectionChanged: '&onSelectionChanged'
            },
            templateUrl: 'scheduler/templates/wb-scheduler.tpl.html',
            replace: true,
            controller: ["$scope", function ($scope) {

                var commandDropdown = null;                

                $scope.$watch('sourceSettings', function(newValue) {
                    $scope.option = angular.extend({}, angular.copy(defaultSettings), newValue);

                    wbSchedulerSvc.calculateColumns($scope.option);
                    wbSchedulerSvc.calculateRows($scope.option);
                    wbSchedulerSvc.calculateSizes($scope.option);
                    wbSchedulerSvc.calculateEvents($scope.option);
                    wbSchedulerSvc.calculateAvailability($scope.option);

                    $scope.toolTipEnabled = true;
                }, true);
                
                $scope.isAlternateRow = function(rowIndex) {
                    return wbSchedulerSvc.isAlternateRow(rowIndex, $scope.option);
                }
                
                $scope.selection = {};

                var isSelectable = !!$scope.sourceSettings.commands && !!$scope.sourceSettings.commands.length;

                var selectionStart = null;
                var selectionEnd = null;
                var inSelection = false;

                function clearSelection() {
                    selectionStart = null;
                    selectionEnd = null;
                    inSelection = false;
                    setSelection(selectionStart, selectionEnd);
                }

                function setSelection(selectionStart, selectionEnd) {
                    if (!selectionStart ||
                        !selectionEnd ||
                        !isSelectable ||
                        !$scope.sourceSettings.weekView
                    ) {
                        Object.keys($scope.selection).forEach(function(key) { delete $scope.selection[key]; });
                        return;
                    }

                    var newSelection = {};


                    var colStart;
                    var colEnd;
                    var rowStart;
                    var rowEnd;

                    if (selectionStart.colIndex < selectionEnd.colIndex) {
                        colStart = selectionStart.colIndex;
                        colEnd = selectionEnd.colIndex;
                        rowStart = selectionStart.rowIndex;
                        rowEnd = selectionEnd.rowIndex;
                    } else if (selectionStart.colIndex === selectionEnd.colIndex) {
                        colStart = selectionStart.colIndex;
                        colEnd = selectionStart.colIndex;
                        if (selectionStart.rowIndex < selectionEnd.rowIndex) {
                            rowStart = selectionStart.rowIndex;
                            rowEnd = selectionEnd.rowIndex;
                        } else {
                            rowStart = selectionEnd.rowIndex;
                            rowEnd = selectionStart.rowIndex;
                        }
                    } else {
                        colStart = selectionEnd.colIndex;
                        colEnd = selectionStart.colIndex;
                        rowStart = selectionEnd.rowIndex;
                        rowEnd = selectionStart.rowIndex;
                    }

                    for (var col = colStart; col <= colEnd; col++) {
                        var startRow = col === colStart
                            ? rowStart
                            : 0;
                        var endRow = col === colEnd
                            ? rowEnd
                            : $scope.option.rows.length;

                        for(var row = startRow; row <= endRow; row++) {
                            newSelection[row + '-' + col] = true;
                        }
                    }

                    Object.keys($scope.selection).forEach(function(key) {
                        if (!newSelection[key]) {
                            delete $scope.selection[key];
                        }
                    });

                    Object.keys(newSelection).forEach(function(key) {
                        $scope.selection[key] = true;
                    });

                    if ($scope.selectionChanged) {
                        var startEndDates = wbSchedulerSvc.getStartEndDateBySelection(
                            $scope.option, selectionStart, selectionEnd);                        
                        $timeout(function() {
                            $scope.selectionChanged({ selection: startEndDates });
                        });
                    }                    
                }

                function disposeCommandDropdown() {
                    if (!!commandDropdown) {
                        if (!!commandDropdown.destroy) {
                            commandDropdown.destroy();
                        }
                    }

                    commandDropdown = null;
                }


                function showCommandMenu($event, event, startDate, endDate) {
                    disposeCommandDropdown();

                    var commandMenu = [];

                    angular.forEach($scope.sourceSettings.commands, function(c) {

                        if (!$scope.sourceSettings.commands || !$scope.sourceSettings.commands.length) {
                            return;
                        }

                        var isVisible = true;
                        if (!!c.isVisible) {
                            isVisible = c.isVisible(event, startDate, endDate);
                        }

                        if (isVisible) {
                            commandMenu.push({
                                text: $translate.instant(c.text),
                                click:
                                    angular.bind(this, function(event, startDate, endDate) {
                                        disposeCommandDropdown();
                                        c.callback(event, startDate, endDate);
                                    }, event, startDate, endDate)
                            });
                        }
                    });

                    var s = $rootScope.$new(true);
                    s.content = commandMenu;
                    commandDropdown = $dropdown(
                        angular.element($event.target),
                        {
                            scope: s,
                            placement: 'auto bottom',
                            container: 'body',
                            onHide: function() {
                                disposeCommandDropdown();
                            }
                        }
                    );

                    commandDropdown.$promise.then(function () {
                        $timeout(function() {
                            commandDropdown.show();
                        });
                    });
                }

                $scope.onCellMouseDown = function(rowIndex, colIndex) {
                    disposeCommandDropdown();

                    selectionStart = {rowIndex: rowIndex, colIndex: colIndex};
                    selectionEnd = {
                        rowIndex: rowIndex + ($scope.option.selectByBlocks - 1), 
                        colIndex: colIndex
                    };

                    if (wbSchedulerSvc.canSelectRegion(
                        $scope.option, selectionStart, selectionEnd))
                    {
                        inSelection = true;
                        setSelection(selectionStart, selectionEnd);
                    }
                    else
                    {
                        clearSelection();
                    }
                };

                $scope.onCellMouseMove = function(rowIndex, colIndex) {
                    if (inSelection) {
                        if (Math.abs(selectionStart.rowIndex - rowIndex) > 0 &&
                           ((Math.abs(selectionStart.rowIndex - rowIndex) + 1) % $scope.option.selectByBlocks) === 0)
                        {
                            if ($scope.option.maximumSelectedBlocks !== -1)
                            {
                                if (selectionStart.colIndex === colIndex &&
                                    Math.abs(selectionStart.rowIndex - rowIndex ) < $scope.option.maximumSelectedBlocks)
                                {
                                    selectionEnd = { rowIndex: rowIndex, colIndex: colIndex };

                                    if (wbSchedulerSvc.canSelectRegion(
                                        $scope.option, selectionStart, selectionEnd))
                                    {
                                        setSelection(selectionStart, selectionEnd);                                    
                                    }
                                }
                            }
                            else
                            {
                                selectionEnd = {rowIndex: rowIndex, colIndex: colIndex};
                                if (wbSchedulerSvc.canSelectRegion(
                                    $scope.option, selectionStart, selectionEnd))
                                {
                                    setSelection(selectionStart, selectionEnd);                                    
                                }
                            }
                        }
                    }
                };

                $scope.onCellMouseUp = function($event) {
                    inSelection = false;

                    if (!selectionStart || !selectionEnd) {
                        return;
                    }

                    var startEndDates = wbSchedulerSvc.getStartEndDateBySelection(
                        $scope.option, selectionStart, selectionEnd);

                    var event = null;

                    showCommandMenu($event, event, startEndDates.startDate, startEndDates.endDate);
                };

                var secondClickCheck = false;
                var lastClickEvent = null;

                $scope.onSelectEvent = function ($event, event) {
                    clearSelection();
                    disposeCommandDropdown();

                    $scope.option.selectedAction = event.origAction;

                    if (secondClickCheck) {
                        if (lastClickEvent === event) {
                            secondClickCheck = false;
                            lastClickEvent = null;
                            $scope.toolTipEnabled = false;
                            $timeout(function () {
                                $scope.toolTipEnabled = true;
                            }, 5000);
                            showCommandMenu($event, event, event.startTime, event.endTime);
                            return;
                        }
                    }

                    secondClickCheck = true;
                    lastClickEvent = event;

                    $timeout(function() {
                        secondClickCheck = false;
                    }, 800);

                    if ($scope.actionClicked) {
                        $scope.toolTipEnabled = false;

                        $timeout(function() {
                            $scope.actionClicked({ action: $scope.option.selectedAction });
                        });

                        $timeout(function() {
                            $scope.toolTipEnabled = true;
                        }, 5000);
                    }


                };
            }]
        };
    }]);

// Source: wbSchedulerDatePicker.js
angular.module('wb.directives')

.directive('wbSchedulerDatePicker', ['wbSchedulerSvc', function(wbSchedulerSvc) {
    return {
        restrict: 'E',
        scope: {
            sourceSettings: '=settings',
            dateChanged: '&onDateChanged'
        },
        templateUrl: 'scheduler/templates/wb-scheduler-date-picker.tpl.html',
        controller: ["$scope", function ($scope) {

            $scope.onPrevBtnClick = function() {
                var interval = wbSchedulerSvc.selectPrevDate($scope.sourceSettings);
                if ($scope.dateChanged) {
                    $scope.dateChanged(interval);
                }
            };

            $scope.onNextBtnClick = function() {
                var interval = wbSchedulerSvc.selectNextDate($scope.sourceSettings);
                if ($scope.dateChanged) {
                    $scope.dateChanged(interval);
                }
            };

            $scope.onTodayBtnClick = function() {
                var interval = wbSchedulerSvc.selectToday($scope.sourceSettings);
                if ($scope.dateChanged) {
                    $scope.dateChanged(interval);
                }
            };

            $scope.onDatePickerChange = function() {
                var interval = wbSchedulerSvc.fixSelectedDate($scope.sourceSettings);
                if ($scope.dateChanged) {
                    $scope.dateChanged(interval);
                }
            }
        }]
    }
}]);

// Source: wbSchedulerRecurrence.js
angular.module('wb.directives')

    .directive('wbSchedulerRecurrence', ['wbSchedulerSvc', function(wbSchedulerSvc) {
        return {
            restrict: 'AE',
            require: 'ngModel',
            scope: {
                ngModel: '=ngModel'
            },
            templateUrl: 'scheduler/templates/wb-scheduler-recurrence.tpl.html',
            link: function (scope, elm, attrs, controller) {

                scope.model = {};

                controller.$render = function () {
                    scope.model = wbSchedulerSvc.mapRecurrenceDtoToModel(scope.model, controller.$viewValue);
                };

                scope.$watch('ngModel', function(newValue) {
                    scope.model = wbSchedulerSvc.mapRecurrenceDtoToModel(scope.model, controller.$viewValue);
                }, true);

                scope.$watch('model', function(newValue) {
                    controller.$setViewValue(wbSchedulerSvc.mapRecurrenceModelToDto(controller.$viewValue, newValue));
                }, true);

            }
        }
    }]);

// Source: wbSchedulerRecurrenceDayPeriodicity.js
angular.module('wb.directives')

    .directive('wbSchedulerRecurrenceDayPeriodicity', [function() {
        return {
            restrict: 'AE',
            require: 'ngModel',
            scope: {
                ngModel: '=ngModel'
            },
            templateUrl: 'scheduler/templates/wb-scheduler-recurrence-day-periodicity.tpl.html',
            link: function (scope, element, attr, ngModel) {

            }
        }
    }]);

// Source: wbSchedulerRecurrenceDayWeekDays.js
angular.module('wb.directives')

    .directive('wbSchedulerRecurrenceDayWeekDays', [function() {
        return {
            restrict: 'AE',
            require: 'ngModel',
            scope: {
                ngModel: '=ngModel'
            },
            templateUrl: 'scheduler/templates/wb-scheduler-recurrence-day-week-days.tpl.html',
            link: function (scope, element, attr, ngModel) {

            }
        }
    }]);

// Source: wbSchedulerRecurrenceMonthCombo.js
angular.module('wb.directives')
    .directive('wbSchedulerRecurrenceMonthCombo', ['$timeout', '$translate',
    function ($timeout, $translate) {
        function formatResult(data) {
            if (!data) { return; }
            return $translate.instant(data.text);
        }

        function formatSelection(data) {
            return $translate.instant(data.text);
        }

        return {
            restrict: 'AE',
            require: 'ngModel',
            link: function (scope, elm, attrs, controller) {

                $timeout(function () {
                    $(elm).select2({
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: false,
                        minimumResultsForSearch: -1,
                        data: [
                            { id: 1, text: 'TXT_RECURRENCE_MONTH_JANUARY' },
                            { id: 2, text: 'TXT_RECURRENCE_MONTH_FEBRUARY' },
                            { id: 3, text: 'TXT_RECURRENCE_MONTH_MARCH' },
                            { id: 4, text: 'TXT_RECURRENCE_MONTH_APRIL' },
                            { id: 5, text: 'TXT_RECURRENCE_MONTH_MAY' },
                            { id: 6, text: 'TXT_RECURRENCE_MONTH_JUNE' },
                            { id: 7, text: 'TXT_RECURRENCE_MONTH_JULY' },
                            { id: 8, text: 'TXT_RECURRENCE_MONTH_AUGUST' },
                            { id: 9, text: 'TXT_RECURRENCE_MONTH_SEPTEMBER' },
                            { id: 10, text: 'TXT_RECURRENCE_MONTH_OCTOBER' },
                            { id: 11, text: 'TXT_RECURRENCE_MONTH_NOVEMBER' },
                            { id: 12, text: 'TXT_RECURRENCE_MONTH_DECEMBER' }
                        ]
                    });

                    controller.$render = function () {
                        elm.select2('val', controller.$viewValue);
                    };

                    controller.$parsers.unshift(function (viewValue) {
                        if (!viewValue) {
                            return 0;
                        } else {
                            return parseInt(viewValue);
                        }
                    });

                    controller.$formatters.unshift(function (value) {
                        if (!value) {
                            return "0";
                        } else {
                            return value + "";
                        }
                    });

                    elm.on('change', function () {
                        scope.$apply(function () {
                            controller.$setViewValue(elm.select2('val'));
                        });
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    controller.$render();

                }, 1);
            }
        }
    }]);

// Source: wbSchedulerRecurrenceMonthPeriodicity.js
angular.module('wb.directives')

    .directive('wbSchedulerRecurrenceMonthPeriodicity', [function() {
        return {
            restrict: 'AE',
            require: 'ngModel',
            scope: {
                ngModel: '=ngModel'
            },
            templateUrl: 'scheduler/templates/wb-scheduler-recurrence-month-periodicity.tpl.html',
            link: function (scope, element, attr, ngModel) {

            }
        }
    }]);

// Source: wbSchedulerRecurrenceMonthWeekDays.js
angular.module('wb.directives')

    .directive('wbSchedulerRecurrenceMonthWeekDays', [function() {
        return {
            restrict: 'AE',
            require: 'ngModel',
            scope: {
                ngModel: '=ngModel'
            },
            templateUrl: 'scheduler/templates/wb-scheduler-recurrence-month-week-days.tpl.html',
            link: function (scope, element, attr, ngModel) {

            }
        }
    }]);

// Source: wbSchedulerRecurrenceWeekDaysCombo.js
angular.module('wb.directives')
    .directive('wbSchedulerRecurrenceWeekDaysCombo', ['$timeout', '$translate',
    function ($timeout, $translate) {
        function formatResult(data) {
            if (!data) { return; }
            return $translate.instant(data.text);
        }

        function formatSelection(data) {
            return $translate.instant(data.text);
        }

        return {
            restrict: 'AE',
            require: 'ngModel',
            link: function (scope, elm, attrs, controller) {

                $timeout(function () {
                    $(elm).select2({
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: false,
                        minimumResultsForSearch: -1,
                        data: [
                            { id: 1, text: 'TXT_RECURRENCE_WEEK_DAYS_SUNDAY' },
                            { id: 2, text: 'TXT_RECURRENCE_WEEK_DAYS_MONDAY' },
                            { id: 4, text: 'TXT_RECURRENCE_WEEK_DAYS_TUESDAY' },
                            { id: 8, text: 'TXT_RECURRENCE_WEEK_DAYS_WEDNESDAY' },
                            { id: 16, text: 'TXT_RECURRENCE_WEEK_DAYS_THURSDAY' },
                            { id: 32, text: 'TXT_RECURRENCE_WEEK_DAYS_FRIDAY' },
                            { id: 64, text: 'TXT_RECURRENCE_WEEK_DAYS_SATURDAY' }
                        ]
                    });

                    controller.$render = function () {
                        elm.select2('val', controller.$viewValue);
                    };

                    controller.$parsers.unshift(function (viewValue) {
                        if (!viewValue) {
                            return 0;
                        } else {
                            return parseInt(viewValue);
                        }
                    });

                    controller.$formatters.unshift(function (value) {
                        if (!value) {
                            return "0";
                        } else {
                            return value + "";
                        }
                    });

                    elm.on('change', function () {
                        scope.$apply(function () {
                            controller.$setViewValue(elm.select2('val'));
                        });
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    controller.$render();

                }, 1);
            }
        }
    }]);

// Source: wbSchedulerRecurrenceWeekOfMonthCombo.js
angular.module('wb.directives')
    .directive('wbSchedulerRecurrenceWeekOfMonthCombo', ['$timeout', '$translate',
    function ($timeout, $translate) {
        function formatResult(data) {
            if (!data) { return; }
            return $translate.instant(data.text);
        }

        function formatSelection(data) {
            return $translate.instant(data.text);
        }

        return {
            restrict: 'AE',
            require: 'ngModel',
            link: function (scope, elm, attrs, controller) {

                $timeout(function () {
                    $(elm).select2({
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: false,
                        minimumResultsForSearch: -1,
                        data: [
                            { id: 1, text: 'TXT_RECURRENCE_WEEK_OF_MONTH_FIRST' },
                            { id: 2, text: 'TXT_RECURRENCE_WEEK_OF_MONTH_SECOND' },
                            { id: 3, text: 'TXT_RECURRENCE_WEEK_OF_MONTH_THIRD' },
                            { id: 4, text: 'TXT_RECURRENCE_WEEK_OF_MONTH_FOURTH' },
                            { id: 5, text: 'TXT_RECURRENCE_WEEK_OF_MONTH_LAST' }
                        ]
                    });

                    controller.$render = function () {
                        elm.select2('val', controller.$viewValue);
                    };

                    controller.$parsers.unshift(function (viewValue) {
                        if (!viewValue) {
                            return 0;
                        } else {
                            return parseInt(viewValue);
                        }
                    });

                    controller.$formatters.unshift(function (value) {
                        if (!value) {
                            return "0";
                        } else {
                            return value + "";
                        }
                    });

                    elm.on('change', function () {
                        scope.$apply(function () {
                            controller.$setViewValue(elm.select2('val'));
                        });
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    controller.$render();

                }, 1);
            }
        }
    }]);

// Source: wbSchedulerRecurrenceWeekPeriodicity.js
angular.module('wb.directives')

    .directive('wbSchedulerRecurrenceWeekPeriodicity', [function() {
        return {
            restrict: 'AE',
            require: 'ngModel',
            scope: {
                ngModel: '=ngModel'
            },
            templateUrl: 'scheduler/templates/wb-scheduler-recurrence-week-periodicity.tpl.html',
            link: function (scope, element, attr, ngModel) {

            }
        }
    }]);

// Source: wbSchedulerRecurrenceWeekWeekDays.js
angular.module('wb.directives')

    .directive('wbSchedulerRecurrenceWeekWeekDays', [function() {
        return {
            restrict: 'AE',
            require: 'ngModel',
            scope: {
                ngModel: '=ngModel'
            },
            templateUrl: 'scheduler/templates/wb-scheduler-recurrence-week-week-days.tpl.html',
            link: function (scope, element, attr, ngModel) {

            }
        }
    }]);

// Source: wbSchedulerRecurrenceYearPeriodicity.js
angular.module('wb.directives')

    .directive('wbSchedulerRecurrenceYearPeriodicity', [function() {
        return {
            restrict: 'AE',
            require: 'ngModel',
            scope: {
                ngModel: '=ngModel'
            },
            templateUrl: 'scheduler/templates/wb-scheduler-recurrence-year-periodicity.tpl.html',
            link: function (scope, element, attr, ngModel) {

            }
        }
    }]);

// Source: wbSchedulerRecurrenceYearWeekDays.js
angular.module('wb.directives')

    .directive('wbSchedulerRecurrenceYearWeekDays', [function() {
        return {
            restrict: 'AE',
            require: 'ngModel',
            scope: {
                ngModel: '=ngModel'
            },
            templateUrl: 'scheduler/templates/wb-scheduler-recurrence-year-week-days.tpl.html',
            link: function (scope, element, attr, ngModel) {

            }
        }
    }]);

// Source: wbSchedulerResourceCombo.js
angular.module('wb.directives')

    .directive('wbSchedulerResourceCombo', ['$timeout', 'wbSchedulerSvc', function($timeout, wbSchedulerSvc) {

        function formatResult(item) {
            if (!item) { return; }
            return item.name;
        }


        return {
            restrict: 'E',
            scope: {
                sourceSettings: '=settings'
            },
            replace: true,
            priority: 1,
            link: function (scope, elm, attrs) {

                var lastWeekViewValue = scope.sourceSettings.weekView;
                var lastVisibleResources = scope.sourceSettings.visibleResources;

                function formatSelection(item) {

                    if (!item) {
                        return '';
                    }

                    var selectedResources = wbSchedulerSvc.getSelectedResources(
                        scope.sourceSettings,
                        wbSchedulerSvc.getMappedResourceID(scope.sourceSettings.resourcesMapping, item));
                    var caption = null;

                    angular.forEach(selectedResources, function(item) {
                       if (caption === null) {
                           caption = item.name;
                       } else {
                           caption += ', ' + item.name;
                       }
                    });

                    return caption || '';
                }

                $timeout(function () {
                    $(elm).select2({
                        minimumResultsForSearch: -1,
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        id: function(resource) { return wbSchedulerSvc.getMappedResourceID(scope.sourceSettings.resourcesMapping, resource); },
                        data: scope.sourceSettings.resources
                    });

                    elm.on('change', function (event) {
                        scope.$apply(function () {
                            scope.sourceSettings.selectedResourceID = parseInt(event.val || '0');
                        });
                    });

                    scope.$watch('sourceSettings', function(newValue) {
                        var currentVal = parseInt($(elm).select2('val') || '0');

                        var validResourceID = wbSchedulerSvc.getValidSelectedResourceID(newValue, newValue.selectedResourceID);

                        if (validResourceID !== currentVal ||
                            lastWeekViewValue !== scope.sourceSettings.weekView ||
                            lastVisibleResources !== scope.sourceSettings.visibleResources) {

                            lastWeekViewValue = scope.sourceSettings.weekView;
                            lastVisibleResources = scope.sourceSettings.visibleResources;

                            scope.sourceSettings.selectedResourceID =
                                !validResourceID ? 0 : validResourceID;

                            $(elm).select2('val',
                                !validResourceID ? '0' : validResourceID + '');
                        }
                    }, true);

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });


                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });
                });

            }
        }
    }]);

// Source: wbSchedulerSvc.js
angular.module('wb.directives')

.factory('wbSchedulerSvc', ['$filter',
    function($filter) {
function findColumn(settings, event) {
            var startDay = moment(event.startDate).startOf('day');
            for (var c = 0; c < settings.columns.length; c++) {
                var column = settings.columns[c];
                if (moment(column.date).isSame(startDay)) {
                    if (event.resourceID == column.resourceID) {
                        return c;
                    }
                }
            }

            return -1;
        }

        function calcStartTime(settings, startHour, startMinute, startDate, columnDate) {
            var min = 0;
            var res = (startHour * (60 / settings.scale)) + (startMinute / settings.scale);
            if (min > res) {
                return {
                    startTime: min,
                    startOverflow: true,
                    startOverflowDay: moment(startDate).startOf('day').isBefore(moment(columnDate).startOf('day'))
                };
            } else {
                return {
                    startTime: res,
                    startOverflow: false,
                    startOverflowDay: false
                };
            }
        }

        function calcEndTime(settings, endHour, endMinute, endDate, columnDate) {
            var max = (60 / settings.scale) * (settings.endHour - settings.startHour);
            var res = (endHour * (60 / settings.scale)) + (endMinute / settings.scale);
            if (max < res) {
                return {
                    endTime: max,
                    endOverflow: true,
                    endOverflowDay: moment(endDate).startOf('day').isAfter(moment(columnDate).startOf('day'))
                };
            } else {
                return {
                    endTime: res,
                    endOverflow: false,
                    endOverflowDay: false
                };
            }
        }

        function limitEvents(settings, event, events) {
            var column = findColumn(settings, event);
            if (column === -1) {
                return;
            }

            var mStartDate = moment(event.startDate);
            var mEndDate = moment(event.endDate);

            var startHour = mStartDate.hour() - settings.startHour;
            var startMinute = mStartDate.minute();

            var endHour = mEndDate.hour() - settings.startHour;
            var endMinute = mEndDate.minute();

            // Event ends earlier that the displayed min time
            if (endHour < 0 || (endHour === 0 && endMinute === 0)) {
                return;
            }

            // Event starts later than the displayed max time
            if (startHour >= (settings.endHour - settings.startHour)) {
                return;
            }

            event.startHour = startHour;
            event.startMinute = startMinute;
            event.endHour = endHour;
            event.endMinute = endMinute;
            event.column = column;

            events.push(event);
        }

        // removes actions which are outside of boundaries and should not influence layout
        // also breaks longer events by day
        function preFilterActions(settings, actions) {
            var result = [];

            angular.forEach(actions, function(action) {
                var mStartDate = moment(action.startDate);
                var mEndDate = moment(action.endDate);

                if (mStartDate.isAfter(mEndDate)) {
                    return; // Invalid event
                }

                var mStartDateStartOfDay = moment(action.startDate).startOf('day');
                var mEndDateStartOfDay = moment(action.endDate).startOf('day');

                var mCurrentStartDate = moment(action.startDate);
                var mCurrentEndDate = moment(action.endDate);

                while(true) {

                    var mCurrentStartDateStartOfDay = moment(mCurrentStartDate).startOf('day');

                    if (mCurrentStartDateStartOfDay.isAfter(mStartDateStartOfDay)) {
                        mCurrentStartDate = mCurrentStartDateStartOfDay;
                    }

                    if (mCurrentStartDateStartOfDay.isBefore(mEndDateStartOfDay)) {
                        mCurrentEndDate = moment(mCurrentStartDate).endOf('day');
                    } else {
                        mCurrentEndDate = moment(mCurrentStartDateStartOfDay);
                        mCurrentEndDate.set('hour', mEndDate.get('hour'));
                        mCurrentEndDate.set('minute', mEndDate.get('minute'));
                        mCurrentEndDate.set('second', mEndDate.get('second'));
                    }

                    var resourceID = action[getResourceIDPropertyName(settings.actionsMapping)];

                    var event = {
                        startDate: mCurrentStartDate.toDate(),
                        endDate: mCurrentEndDate.toDate(),
                        resourceID: resourceID,
                        origAction: action
                    };

                    limitEvents(settings, event, result);

                    if (mEndDateStartOfDay.isSame(mCurrentStartDateStartOfDay)) {
                        break;
                    }

                    mCurrentStartDate.add(1, 'days').startOf('day');
                }
            });

            return _.sortBy(result, function(action) { return (action.column * 1000) + (action.startHour * 60) + action.startMinute; } );
        }

        function detectOverlaps(settings) {
            var group = [];
            if (settings.events.length > 1) {
                for (var e = 1; e < settings.events.length; e++) {
                    var lastEvent = settings.events[e - 1];
                    var event = settings.events[e];
                    if (event.start < lastEvent.end && event.column === lastEvent.column) {
                        if (group.length === 0) {
                            group.push(lastEvent);
                            group.push(event);
                        } else {
                            group.push(event);
                        }
                    } else {
                        if (group.length > 1) {
                            for(var g = 0; g < group.length; g++) {
                                var element = group[g];
                                element.noOfSubColumns = group.length;
                                element.subColumn = g;
                            }
                            group = [];
                        }
                    }
                }
            }

            if (group.length > 1) {
                angular.forEach(group, function(element, index) {
                    element.noOfSubColumns = group.length;
                    element.subColumn = index;
                });
            }
        }

        function calculateEventsImpl(settings, actions) {

            var filteredActions = preFilterActions(settings, actions);

            angular.forEach(filteredActions, function(action) {
                var startFix = calcStartTime(settings, action.startHour, action.startMinute,
                    action.origAction.startDate, settings.columns[action.column].date);
                var endFix = calcEndTime(settings, action.endHour, action.endMinute,
                    action.origAction.endDate, settings.columns[action.column].date);

                var event = {
                    column: action.column,
                    noOfSubColumns: 1,
                    subColumn: 0,
                    start: startFix.startTime,
                    startOverflow: startFix.startOverflow,
                    startOverflowDay: startFix.startOverflowDay,
                    end: endFix.endTime,
                    endOverflow: endFix.endOverflow,
                    endOverflowDay: endFix.endOverflowDay,
                    name: action.origAction[getMappedPropertyName(settings.actionsMapping, 'name')],
                    status: action.origAction.status || 1,
                    type: action.origAction.type || 1,
                    startTime: action.origAction.startDate,
                    endTime: action.origAction.endDate,
                    teacher: action.origAction[getMappedPropertyName(settings.actionsMapping, 'teacher')],
                    filled: action.origAction[getMappedPropertyName(settings.actionsMapping, 'filled')],
                    showWaitQueue: action.origAction.showWaitQueue,
                    showActionNote: action.origAction.showActionNote,
                    origAction: action.origAction,
                    notes: action.origAction[getMappedPropertyName(settings.actionsMapping, 'notes')],
                    recurrenceType: action.origAction[getMappedPropertyName(settings.actionsMapping, 'recurrenceType')]
                };
                settings.events.push(event);
            });

            detectOverlaps(settings);
        }

        function calculateEvents(settings) {
            calculateEventsImpl(settings, settings.actions);
        }

        function selectPrevDate(settings) {
            var ret = {
                startDate: settings.startDate,
                endDate: settings.startDate
            };

            if (settings.weekView) {
                settings.startDate = moment(settings.startDate)
                    .startOf('isoWeek')
                    .add(-7, 'd')
                    .toDate();

                ret.startDate = settings.startDate;
                ret.endDate = moment(settings.startDate).add(7, 'd').toDate();
            } else {
                settings.startDate = moment(settings.startDate)
                    .startOf('day')
                    .add(-1, 'd')
                    .toDate();
                ret.startDate = settings.startDate;
                ret.endDate = moment(settings.startDate).add(1, 'd').toDate();
            }

            return ret;
        }

        function selectNextDate(settings) {
            var ret = {
                startDate: settings.startDate,
                endDate: settings.startDate
            };

            if (settings.weekView) {
                settings.startDate = moment(settings.startDate)
                    .startOf('isoWeek')
                    .add(7, 'd')
                    .toDate();

                ret.startDate = settings.startDate;
                ret.endDate = moment(settings.startDate).add(7, 'd').toDate();
            } else {
                settings.startDate = moment(settings.startDate)
                    .startOf('day')
                    .add(1, 'd')
                    .toDate();
                ret.startDate = settings.startDate;
                ret.endDate = moment(settings.startDate).add(1, 'd').toDate();
            }

            return ret;
        }

        function selectToday(settings) {
            var ret = {
                startDate: settings.startDate,
                endDate: settings.startDate
            };

            if (settings.weekView) {
                settings.startDate = moment()
                    .startOf('isoWeek')
                    .toDate();

                ret.startDate = settings.startDate;
                ret.endDate = moment(settings.startDate).add(7, 'd').toDate();
            } else {
                settings.startDate = moment().startOf('day').toDate();
                ret.startDate = settings.startDate;
                ret.endDate = moment(settings.startDate).add(1, 'd').toDate();
            }

            return ret;
        }

        function fixSelectedDate(settings) {
            var ret = {
                startDate: settings.startDate,
                endDate: settings.startDate
            };

            if (settings.weekView) {
                var shouldBeSelected = moment(settings.startDate).startOf('isoweek');
                var isSelected = moment(settings.startDate);

                if (!shouldBeSelected.isSame(isSelected)) {
                    settings.startDate = shouldBeSelected.toDate();
                }

                ret.startDate = settings.startDate;
                ret.endDate = moment(settings.startDate).add(7, 'd').toDate();
            } else {
                ret.endDate = moment(settings.startDate).add(1, 'd').toDate();
            }

            return ret;
        }

        function shouldShowWeekend(settings, selectedResources, startDate) {

            var saturdayStartDay = startDate.clone().isoWeekday(6).startOf('day');
            var sundayEndDay = startDate.clone().isoWeekday(7).endOf('day');

            for (var a = 0; a < settings.actions.length; a++) {
                var action = settings.actions[a];

                var actionStartDate = moment(action.startDate);
                var actionEndDate = moment(action.endDate);

                if (actionStartDate.isBefore(sundayEndDay) && actionEndDate.isAfter(saturdayStartDay)) {

                    if (_.find(selectedResources, function(resource) {
                            var actionResourceID = action[getMappedPropertyName(settings.actionsMapping, 'resourceID')];
                            var resourceResourceID = resource[getMappedPropertyName(settings.recourcesMapping, 'resourceID')];
                            return actionResourceID == resourceResourceID;
                        } ))
                    {
                        return true;
                    }
                }
            }

            return false;
        }

        function getMappedPropertyName(mapping, defaultPropertyName) {
            if (mapping && mapping[defaultPropertyName]) {
                return mapping[defaultPropertyName];
            }
            return defaultPropertyName;
        }

        function getResourceIDPropertyName(resourcesMapping) {
            return getMappedPropertyName(resourcesMapping, 'resourceID');
        }

        function getMappedResourceID(resourcesMapping, model) {
            if (resourcesMapping && resourcesMapping.resourceID) {
                return model[resourcesMapping.resourceID];
            }
            return model.resourceID;
        }

        function getSelectedResourceIDStartIndex(settings, selectedResourceID) {
            var findSettings = {};
            findSettings[getResourceIDPropertyName(settings.resourcesMapping)] = selectedResourceID;
            var resourceStartIdx = selectedResourceID
                ? _.findIndex(settings.resources, findSettings)
                : 0;
            if (resourceStartIdx < 0) {
                resourceStartIdx = 0;
            }

            return resourceStartIdx;
        }

        function getValidSelectedResourceID(settings, selectedResourceID) {
            if (settings.resources.length) {
                var resourceStartIdx = getSelectedResourceIDStartIndex(settings, selectedResourceID);
                return settings.resources[resourceStartIdx][getResourceIDPropertyName(settings.resourcesMapping)];
            } else {
                return selectedResourceID;
            }
        }

        function getSelectedResources(settings, selectedResourceID) {
            var resources = [];

            var resourcesLimit;

            var resourceStartIdx = getSelectedResourceIDStartIndex(settings, selectedResourceID);

            if (settings.weekView) {
                resourcesLimit = 1;
            } else {
                resourcesLimit = Math.min(settings.visibleResources, settings.resources.length) || 1;
            }

            for (var r = 0; r < resourcesLimit; r++) {
                var idx = resourceStartIdx + r;
                if (settings.resources.length !== 0) {
                    var res = settings.resources[idx % settings.resources.length];
                    resources.push({
                        name: res.name,
                        resourceID: res[getResourceIDPropertyName(settings.resourcesMapping)],
                        origResource: res
                    });
                } else {
                    var emptyResource = { name: '', origResource: null };
                    emptyResource[getResourceIDPropertyName(settings.resourcesMapping)] = 0;
                    resources.push(emptyResource);
                }
            }

            return resources;
        }

        function calculateColumns(settings) {

            var today = moment().startOf('day');
            settings.todayIndex = -1;

            var daysLimit, startDate;

            var selectedResources = getSelectedResources(settings, settings.selectedResourceID);

            if (settings.weekView) {
                startDate = moment(settings.startDate).startOf('isoWeek');
                daysLimit = settings.showWeekend || shouldShowWeekend(settings, selectedResources, startDate) ? 7 : 5;
            } else {
                daysLimit = 1;
                startDate = moment(settings.startDate).startOf('day');
            }

            for (var d = 0; d < daysLimit; d++) {
                if (today.isSame(startDate)) {
                    settings.todayIndex = d;
                }
                var clonedDate = startDate.clone().toDate();

                for (var r = 0; r < selectedResources.length; r++) {
                    var resource = selectedResources[r];

                    settings.columns.push({
                        date: clonedDate,
                        resourceID: resource.resourceID,
                        resourceName: resource.name,
                        caption: settings.weekView
                            ? $filter('date')(clonedDate, 'EEE d. MMM')
                            : resource.name
                    });
                }
                startDate.add(1, 'days');
            }
        }

        function canSelectRegion(settings, selectionStart, selectionEnd)
        {
            if (!settings.availability) {
                return true;
            }

            var reverse = (selectionStart.colIndex > selectionEnd.colIndex) ||
                (selectionStart.colIndex == selectionEnd.colIndex &&
                 selectionStart.rowIndex > selectionEnd.rowIndex);

            var startRowIdx = reverse
                ? selectionEnd.rowIndex
                : selectionStart.rowIndex;
            var startCol = reverse
                ? selectionEnd.colIndex
                : selectionStart.colIndex;

            var endRowIdx = reverse
                ? selectionStart.rowIndex
                : selectionEnd.rowIndex;

            var endCol = reverse
                ? selectionStart.colIndex
                : selectionEnd.colIndex; 
                
            var origStartRowIdx = startRowIdx;

            while(startCol <= endCol)
            {
                if (startCol >= settings.columns.length) {
                    break;
                }

                endRowIdx = startCol < endCol
                    ? settings.rows.length
                    : selectionEnd.rowIndex;

                while(startRowIdx <= endRowIdx) 
                {
                    if (!settings.availabilityObj[startRowIdx + '-' + startCol]) {
                        return false;
                    }

                    startRowIdx = startRowIdx + 1;
                }

                startCol = startCol + 1;
                startRowIdx = 0;
            }

            var divider = 15;
            switch(settings.scale)
            {
                case 15:
                    divider = 2;
                    break;
                case 30:
                    divider = 1;
                    break;
            }
            
            switch(settings.startTimeType) {
                case 1: // CanStartAtWholeOrHalfHour
                    if ((origStartRowIdx % divider) !== 0) {
                        return false;
                    }
                    break;
                case 2: // CanStartAtWholeHourOnly
                    if (origStartRowIdx % (2 * divider) !== 0) {
                        return false;
                    }
                    break;
                case 3: // CanStartAtHalfHourOnly
                    if (origStartRowIdx % (2 * divider) !== divider) {
                        return false;
                    }
                    break;
                case 4: // CanStartAtSelectByBlocksConsecutive   
                    if ((origStartRowIdx % settings.selectByBlocks) !== 0) {
                        return false;
                    }
                    break;
            }

            return true;
        }
        
        function isAlternateRow(rowIndex, settings) {
            var divider = 15;
            switch(settings.scale)
            {
                case 15:
                    divider = 2;
                    break;
                case 30:
                    divider = 1;
                    break;
            }

            switch(settings.startTimeType)
            {
                case 1: // CanStartAtWholeOrHalfHour
                    return ~~(rowIndex/divider) % 2;
                case 2: // CanStartAtWholeHourOnly
                    return ~~(rowIndex/(2 * divider)) % 2;
                case 3: // CanStartAtHalfHourOnly
                    return ~~((rowIndex + divider)/(2 * divider)) % 2;
                case 4: // CanStartAtSelectByBlocksConsecutive
                    return ~~(rowIndex/settings.selectByBlocks) % 2;
                default:
                    return false;
            }            
        }

        function calculateAvailability(settings) {
            
            settings.availabilityObj = {};
            var startDate;

            if (settings.weekView) {
                startDate = moment(settings.startDate).startOf('isoWeek');
            } else {
                startDate = moment(settings.startDate).startOf('day');
            }

            _.forEach(settings.availability || [], function(a) {
                var a_startDate = moment(a.start);
                var a_endDate = moment(a.end);
                var colIndex = a_startDate.diff(startDate, 'days');

                var startDateOffset = moment(a_startDate).subtract(settings.startHour, 'hours');
                var startIndex = 
                    (startDateOffset.hour() * settings.noOfSubRows) +
                    (startDateOffset.minute() / settings.scale);

                var endDateOffset = moment(a_endDate).subtract(settings.startHour, 'hours');
                var endIndex = 
                    (endDateOffset.hour() * settings.noOfSubRows) +
                    (endDateOffset.minute() / settings.scale);                    

                for(var i = startIndex; i < endIndex; i++) 
                {
                    settings.availabilityObj[i + '-' + colIndex] = true;
                }
            });            
        }

        function colIndexToDate(settings, colIndex) {
            return settings.columns[colIndex].date;
        }

        function rowIndexToTime(settings, rowIndex, isStartTime) {
            var row = settings.rows[rowIndex];
            if (isStartTime) {
                return {
                    hour: row.hour,
                    minute: row.subIndex * (60 / settings.noOfSubRows)
                }
            } else {
                return {
                    hour: row.hour,
                    minute: (row.subIndex + 1) * (60 / settings.noOfSubRows)
                }
            }
        }

        function getDateByRowAndColIndex(settings, colIndex, rowIndex, isStartTime) {
            var date  = colIndexToDate(settings, colIndex);
            var hour = rowIndexToTime(settings, rowIndex, isStartTime);

            return moment(date).startOf('day').add(hour.hour, 'h').add(hour.minute, 'm').toDate();
        }

        function getStartEndDateBySelection(settings, selectionStart, selectionEnd) {

            if (selectionStart.colIndex < selectionEnd.colIndex ||
                   (selectionStart.colIndex === selectionEnd.colIndex &&
                    selectionStart.rowIndex < selectionEnd.rowIndex)) {

                return {
                    startDate: getDateByRowAndColIndex(
                        settings, selectionStart.colIndex, selectionStart.rowIndex, true),
                    endDate: getDateByRowAndColIndex(
                        settings, selectionEnd.colIndex, selectionEnd.rowIndex, false)
                };
            } else {
                return {
                    startDate: getDateByRowAndColIndex(
                        settings, selectionEnd.colIndex, selectionEnd.rowIndex, true),
                    endDate: getDateByRowAndColIndex(
                        settings, selectionStart.colIndex, selectionStart.rowIndex, false)
                };
            }
        }

        function calcStartEndHours(settings) {

            var visibleStartDateActions = [];
            var visibleEndDateActions = [];
            var startHour = settings.startHour || 8;
            var endHour = settings.endHour || 20;

            for (var a = 0; a < settings.actions.length; a++) {
                var action = settings.actions[a];

                var actionStartDate = moment(action.startDate);
                var actionEndDate = moment(action.endDate);

                var actionStartDateDay = actionStartDate.clone().startOf('day');
                var actionEndDateDay = actionEndDate.clone().startOf('day');

                // Find if this action should be displayed
                for(var c = 0; c < settings.columns.length; c++) {
                    var column = settings.columns[c];

                    var columnDate = moment(column.date);

                    var actionResourceID = action[getMappedPropertyName(settings.actionsMapping, 'resourceID')];

                    if (actionResourceID == column.resourceID) {
                        if (columnDate.isSame(actionStartDateDay)) {
                            visibleStartDateActions.push(action);
                        }
                        if (columnDate.isSame(actionEndDateDay)) {
                            visibleEndDateActions.push(action);
                        }
                    }

                }
            }

            var lowerBound;
            var upperBound;

            if (visibleStartDateActions.length > 0) {
                var startDateSorted = _.sortBy(visibleStartDateActions, function(action) { return moment(action.startDate).hour() * 60 + moment(action.startDate).minute(); } );
                lowerBound = moment(startDateSorted[0].startDate);
                upperBound = moment(startDateSorted[startDateSorted.length - 1].startDate);

                if (settings.autoHourRange) {
                    startHour = lowerBound.hour();
                } else {
                    if (startHour > lowerBound.hour()) {
                        startHour = lowerBound.hour();
                    }

                    if (endHour < upperBound.hour()) {
                        endHour = upperBound.hour();
                        if (upperBound.minute() > 0) {
                            endHour += 1;
                        }
                    }
                }
            }

            if (visibleEndDateActions.length > 0) {
                var endDateSorted = _.sortBy(visibleEndDateActions, function(action) { return moment(action.endDate).hour() * 60 + moment(action.endDate).minute(); } );
                lowerBound = moment(endDateSorted[0].endDate);
                upperBound = moment(endDateSorted[endDateSorted.length - 1].endDate);

                if (settings.autoHourRange) {
                    endHour = upperBound.hour();
                    if (upperBound.minute() > 0) {
                        endHour += 1;
                    }
                } else {
                    if (endHour < upperBound.hour()) {
                        endHour = upperBound.hour();
                        if (upperBound.minute() > 0) {
                            endHour += 1;
                        }
                    }

                    if (startHour > lowerBound.hour()) {
                        startHour = lowerBound.hour();
                    }
                }
            }

            if (settings.autoHourRange && (endHour - startHour) < 3) {
                endHour = startHour + 3;
            }

            if (settings.autoHourRange && !visibleStartDateActions.length && !visibleEndDateActions.length) {
                endHour = startHour + 3;
            }

            return {
                startHour: startHour,
                endHour: endHour
            }
        }

        function calculateRows(settings) {
            var noOfSubRows = Math.ceil(60.0 / settings.scale);

            settings.noOfSubRows = noOfSubRows;

            var startEndHours = calcStartEndHours(settings);
            settings.startHour = startEndHours.startHour;
            settings.endHour = startEndHours.endHour;

            for(var h = settings.startHour; h < settings.endHour; h++) {
                for (var s = 0; s < noOfSubRows; s++) {
                    settings.rows.push({
                        firstRow: s === 0,
                        lastRow: s === (noOfSubRows - 1),
                        subIndex: s,
                        hour: h
                    });
                }
            }
        }

        function calculateSizes(settings) {
            settings.columnWidth = 100 / settings.columns.length;
            settings.rowHeigh = 100 / settings.rows.length;
        }

        //scope.model = {
        //    recurrenceType: 1,
        //    weekPeriodicity: 1,
        //    weekWeekDays: 0,
        //    dayPeriodicity: 1,
        //    dayWeekDays: 0,
        //    monthRecurrenceType: 0,
        //    monthDayNumber: 1,
        //    monthPeriodicity0: 1,
        //    monthPeriodicity1: 1,
        //    monthWeekDays: 1,
        //    monthWeekOfMonth: 1,
        //    yearRecurrenceType: 0,
        //    yearDayNumber: 1,
        //    yearMonth0: 1,
        //    yearMonth1: 1,
        //    yearWeekOfMonth: 1,
        //    yearWeekDays: 1
        //};

        //enum WeekOfMonth
        //{
        //    None = 0,
        //    First = 1,
        //    Second = 2,
        //    Third = 3,
        //    Fourth = 4,
        //    Last = 5
        //}

        function dateToWeekDays(date) {
            switch(moment(date).day()) {
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 4;
                case 3:
                    return 8;
                case 4:
                    return 16;
                case 5:
                    return 32;
                case 6:
                    return 64;
            }

            return 0;
        }

        function mapRecurrenceDtoToModel(model, dto) {

            model.recurrenceType = dto.type;
            model.range = dto.range;
            model.occurrenceCount = dto.occurrenceCount || 10;
            model.start = dto.start || moment().toDate();
            model.end = dto.end || moment(model.start).add(3, 'month').toDate();

            // RecurrenceType.Daily === 0

            if (model.recurrenceType === 0) {
                model.dayWeekDays = dto.weekDays === 62 ? 62 : 0;
                model.dayPeriodicity = dto.periodicity || 1;
            } else {
                model.dayWeekDays = 0;
                model.dayPeriodicity = 1;
            }

            // RecurrenceType.Weekly === 1
            model.weekPeriodicity = dto.periodicity || 1;
            if (model.recurrenceType === 1) {
                model.weekWeekDays = dto.weekDays || dateToWeekDays(model.start);
            } else {
                model.weekWeekDays = dateToWeekDays(model.start);
            }

            // RecurrenceType.Monthly === 2
            model.monthRecurrenceType = !dto.weekOfMonth ? 0 : 1;
            model.monthDayNumber = dto.dayNumber || 1;
            model.monthWeekOfMonth = dto.weekOfMonth || 1;
            if (model.recurrenceType === 2) {
                model.monthPeriodicity0 = dto.periodicity || 1;
                model.monthPeriodicity1 = dto.periodicity || 1;
                model.monthWeekDays = dto.weekDays || dateToWeekDays(model.start);
            } else {
                model.monthPeriodicity0 = 1;
                model.monthPeriodicity1 = 1;
                model.monthWeekDays = dateToWeekDays(model.start);
            }

            // RecurrenceType.Yearly === 3
            model.yearRecurrenceType = !dto.weekOfMonth ? 0 : 1;
            model.yearWeekOfMonth = dto.weekOfMonth || 1;
            model.yearMonth0 = dto.month || 1;
            model.yearMonth1 = dto.month || 1;
            if (model.recurrenceType === 3) {
                model.yearWeekDays = dto.weekDays || dateToWeekDays(model.start);
                model.yearDayNumber = dto.dayNumber || 1;
            } else {
                model.yearWeekDays = dateToWeekDays(model.start);
                model.yearDayNumber = 1;
            }

            return model;
        }


        function mapRecurrenceModelToDto(dto, model) {
            // Clean up
            Object.keys(dto).forEach(function(key) { delete dto[key]; });

            dto.type = model.recurrenceType;
            dto.range = model.range;
            dto.start = model.start;
            if (model.range == 1) {
                dto.occurrenceCount = model.occurrenceCount;
            } else {
                dto.end = model.end;
            }

            if (model.recurrenceType === 0) {
                if (model.dayPeriodicity !== 1) {
                    dto.periodicity = model.dayPeriodicity;
                }
                if (model.dayWeekDays) {
                    dto.weekDays = model.dayWeekDays;
                }
            } else if (model.recurrenceType === 1) {
                dto.periodicity = model.weekPeriodicity;
                dto.weekDays = model.weekWeekDays;
            } else if (model.recurrenceType === 2) {
                if (model.monthRecurrenceType === 0) {
                    dto.weekOfMonth = 0;
                    dto.dayNumber = model.monthDayNumber;
                    if (model.monthPeriodicity0 !== 1) {
                        dto.periodicity = model.monthPeriodicity0;
                    }
                } else {
                    dto.weekOfMonth = model.monthWeekOfMonth;
                    dto.weekDays = model.monthWeekDays;
                    if (model.monthPeriodicity1 !== 1) {
                        dto.periodicity = model.monthPeriodicity1;
                    }
                }
            } else if (model.recurrenceType === 3) {
                if (model.yearRecurrenceType === 0) {
                    dto.weekOfMonth = 0;
                    dto.month = model.yearMonth0;
                    dto.dayNumber = model.yearDayNumber;
                } else {
                    dto.weekDays = model.yearWeekDays;
                    dto.weekOfMonth = model.yearWeekOfMonth;
                    dto.month = model.yearMonth1;
                }
                dto.periodicity = 1;
            }

            return dto;
        }

    return {
        calculateEvents: calculateEvents,
        selectPrevDate: selectPrevDate,
        selectNextDate: selectNextDate,
        selectToday: selectToday,
        fixSelectedDate: fixSelectedDate,
        calculateColumns: calculateColumns,
        getSelectedResources: getSelectedResources,
        calculateRows: calculateRows,
        calculateSizes: calculateSizes,
        getMappedResourceID: getMappedResourceID,
        getValidSelectedResourceID: getValidSelectedResourceID,
        mapRecurrenceDtoToModel: mapRecurrenceDtoToModel,
        mapRecurrenceModelToDto: mapRecurrenceModelToDto,
        getStartEndDateBySelection: getStartEndDateBySelection,
        calculateAvailability: calculateAvailability,
        canSelectRegion: canSelectRegion,
        isAlternateRow: isAlternateRow
    };
}]);

// Source: wbSplitter.js
angular.module('wb.directives')

    .directive('wbSplitter', ['$compile', function ($compile) {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            scope: {
                orientation: '@'
            },
            template: '<div class="split-panes {{orientation}}"></div>',
            controller: ['$scope', function ($scope) {
                $scope.panes = [];

                this.addPane = function (pane) {
                    if ($scope.panes.length > 1)
                        throw 'splitters can only have two panes';
                    $scope.panes.push(pane);
                    return $scope.panes.length;
                };
            }],
            link: function (scope, element, attrs, ctrl, transclude) {
                var handler = angular.element(
                        '<div class="split-handler">' +
                            '<div ng-click="onMinimizeUp()" ng-show="minified" class="split-handler-button-up"><i class="fa fa-arrow-circle-up hit"></i></div>' +
                            '<div ng-click="onMinimizeDown()" ng-hide="minified" class="split-handler-button-down"><i class="fa fa-arrow-circle-down hit"></i></div>' +
                         '</div>');

                transclude(scope.$parent, function (clone, scope) {
                    element.append(clone);
                });

                var pane1 = scope.panes[0];
                var pane2 = scope.panes[1];
                var vertical = scope.orientation == 'vertical';
                var pane1Min = pane1.minSize || 0;
                var pane2Min = pane2.minSize || 8;
                var pane2Size = pane2.initSize || 100;
                var drag = false;
                var topHeight;
                var lastSize = 0;
                scope.minified = false;

                //scope.style1 = { height: '100px', width: '100px'};

                pane1.elem.after($compile(handler)(scope));

                var h =  element[0].getBoundingClientRect().height;
                setPosition(h - pane2Size, h);

                element.bind('mousemove', function (ev) {
                    if (!drag) return;

                    var bounds = element[0].getBoundingClientRect();
                    var pos = 0;

                    if (vertical) {

                        var height = bounds.bottom - bounds.top;
                        pos = ev.clientY - bounds.top;

                        if (pos < pane1Min) return;
                        if (height - pos < pane2Min) return;

                        setPosition(pos, height);

                    } else {

                        var width = bounds.right - bounds.left;
                        pos = ev.clientX - bounds.left;

                        if (pos < pane1Min) return;
                        if (width - pos < pane2Min) return;

                        handler.css('left', pos + 'px');
                        pane1.elem.css('width', pos + 'px');
                        pane2.elem.css('left', pos + 'px');
                    }
                });

                handler.bind('mousedown', function (ev) {
                    ev.preventDefault();
                    drag = true;
                });

                angular.element(document).bind('mouseup', function (ev) {
                    drag = false;
                });

                scope.onMinimizeUp = function () {
                    var bounds = element[0].getBoundingClientRect();

                    if (vertical) {
                        var pos = lastSize;
                        var height = bounds.bottom - bounds.top;

                        setPosition(pos, height);
                    }
                }

                scope.onMinimizeDown = function () {
                    var bounds = element[0].getBoundingClientRect();
                    var pos = 0;

                    if (vertical) {
                        var height = bounds.bottom - bounds.top;
                        pos = height - handler.height();

                        lastSize = pane1.elem.height();

                        setPosition(pos, height);
                    }
                }

                function setPosition(pos, height) {

                    handler.css('top', pos + 'px');
                    pane1.elem.css('height', pos + 'px');
                    pane2.elem.css('top', pos + 'px');

                    if (topHeight !== pos) {
                        topHeight = pos;
                        $(element).resize();

                        scope.$parent.$broadcast('splitter-pane-resized');
                    }

                    if (pos >= (height - handler.height() - 10)) {
                        scope.minified = true;
                        if (!lastSize) {
                            lastSize = height - 100;
                        }
                    } else {
                        scope.minified = false;
                        lastSize = 0;
                    }
                }
            }
        };
    }])
    .directive('wbPane', function () {
      return {
          restrict: 'EA',
          require: '^wbSplitter',
          replace: true,
          transclude: true,
          scope: {
              minSize: '=',
              initSize: '='
          },
          template:
              '<div class="split-pane{{index}}"></div>',
          link: function (scope, element, attrs, wbSplitterCtrl, transclude) {
              scope.elem = element;
              scope.index = wbSplitterCtrl.addPane(scope);

              transclude(scope.$parent, function (clone, scope) {
                  element.append(clone);
              });
          }
      };
    });

})(window, document);
